import { render, staticRenderFns } from "./GipCafesCulturesLogo.vue?vue&type=template&id=8e1708e0&"
import script from "./GipCafesCulturesLogo.vue?vue&type=script&lang=js&"
export * from "./GipCafesCulturesLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports